import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import { formatDateShort } from '../utils/dateFormat';
import NowName from '../components/shared/NowName';

// New Client registration requests — list page (docs/modules/workflow-client.md).
// The caller's own requests and the ones naming them as reviewer; the named
// reviewer acts from detail. One request may register several companies of
// the same group — the Companies cell lists them all.
const WorkflowClient = () => {
  const { hasPermission } = useAuth();
  return (
    <WorkflowListShell
      title="New Client"
      subtitle="Client registration requests."
      newTo="/workflow/client/new"
      canCreate={hasPermission('workflow:client:submit')}
      apiPath="/api/workflow/client"
      searchPlaceholder="Search request / entity / UEN / group…"
      width="mid"
      rowTo={(r) => `/workflow/client/${r.id}`}
      columns={[
        {
          key: 'requestNo',
          label: 'Request',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/client/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        {
          key: 'entityNames',
          label: 'Companies',
          sortKey: 'entityName',
          className: 'text-slate-900 max-w-md',
          cellTitle: (r) => r.entityNames,
          render: (r) => (
            <span>
              <NowName value={r.entityNames} now={r.entityNamesNow} />
              {r.entityCount > 1 && <span className="ml-1.5 text-xs text-slate-500">({r.entityCount})</span>}
            </span>
          ),
        },
        { key: 'clientGroup', label: 'Client Group', sortKey: 'clientGroup', render: (r) => <NowName value={r.clientGroup} now={r.clientGroupNow} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        { key: 'reviewer', label: 'Reviewer', sortKey: 'reviewer', className: 'whitespace-nowrap', render: (r) => <NowName value={r.reviewerName} now={r.reviewerNameNow} className="text-slate-600" /> },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowClient;
